export const initialState = {
  progress: 0,
  enrollProps: null,
  socketId: null,
  enroll: [],
  showFormError: false,
  enrollFormError: [],
  formError: [],
  duplicatedError: [],
  enrollList: [],
  selectedEnrollList: [],
  selfRegister: false,
  options: {
    fieldOptions: [],
  },
  consent: false,
  formNextButtonDisabled: [],
  nextButtonDisabled: true,
  error: null,
  isInitialLoaded: false,
}
